<form [formGroup]="editStaffForm" class="mx-8 my-4" onSubmit="handleEditAccountOnSubmit()">
  <!-- Profile image section -->
  <nz-form-item>
    <nz-form-control class="flex justify-between rounded-sm">
      <nz-upload nzListType="picture-card">
        <img
          [src]="ASSET_CONSTANTS.I_file_upload"
          alt="upload icon"
          class="w-10 h-10"
        />
      </nz-upload>
    </nz-form-control>
  </nz-form-item>

  <div class="flex flex-col gap-2">
    <div class="flex flex-row gap-2">
      <app-mb-input
          [placeholder]="'Enter First Name'"
          formControlName="firstName"
          [prefixLabel]="'First name:'"
          [errorMessage]="zodErrors['firstName']"
          [hasError]="!!zodErrors['firstName']"
          class="w-full"
      />
      <app-mb-input
            formControlName="lastName"
            prefixLabel="Last Name:"
            placeholder="Enter last name"
            class="w-full"
            [errorMessage]="getFieldError('lastName')"
            [hasError]="!!getFieldError('lastName')"
      />
    </div>
    <div class="flex flex-row gap-2">
      <app-mb-input
        formControlName="email"
        prefixLabel="Email:"
        placeholder="Enter email"
        class="w-full"
        [errorMessage]="getFieldError('email')"
        [hasError]="!!getFieldError('email')"
      />
      <app-mb-input
        type="phone"
        formControlName="phoneNumber"
        prefixLabel="Phone:"
        placeholder="Enter phone number"
        class="w-full"
        [errorMessage]="getFieldError('phoneNumber')"
        [hasError]="!!getFieldError('phoneNumber')"
      />
    </div>
    <div class="flex flex-row gap-2">
      <app-mb-select
        formControlName="role"
        prefixLabel="Role:"
        placeholder="(Admin, Viewer or Staff)"
        [options]="getRoleOptions"
        class="w-full"
        [errorMessage]="getFieldError('role')"
        [hasError]="!!getFieldError('role')"
      />
      <app-mb-select
        formControlName="trackingLevel"
        prefixLabel="Tracking Lvl:"
        placeholder="Select Tracking Level"
        (handleChange)="handleTrackingLevelChange($event)"
        [options]="trackingLevels"
        class="w-full"
        [errorMessage]="getFieldError('trackingLevel')"
        [hasError]="!!getFieldError('trackingLevel')"
      />
    </div>
    <ng-template #tagPlaceHolder let-selectedList
      >and {{ selectedList.length }} more selected</ng-template
    >
    <!-- Placeholder space for tracking level selection -->
    @if (editStaffForm.get('trackingLevel')?.value === '' ||
    editStaffForm.get('trackingLevel')?.value === 'DISTRICT') {
    <div class="h-10"></div>
    }

    <!-- Display location divs based on tracking level -->
    <div *ngIf="editStaffForm.get('trackingLevel')?.value">
      <!-- Single select for district and multiple select for sector -->
      <div
        *ngIf="editStaffForm.get('trackingLevel')?.value === 'SECTOR'"
        class="w-1/2 flex flex-row gap-2"
      >
        <app-mb-select
          formControlName="districtId"
          (handleChange)="onDistrictChange($event)"
          prefixLabel="District:"
          placeholder="Select District"
          [options]="districtOptions"
        />
      </div>

      <!-- Single select for district and sector and multiple select for cell -->
      <div
        *ngIf="editStaffForm.get('trackingLevel')?.value === 'CELL'"
        class="flex flex-row gap-2"
      >
        <app-mb-select
          formControlName="districtId"
          (handleChange)="onDistrictChange($event)"
          prefixLabel="District:"
          placeholder="Select District"
          [options]="districtOptions"
        />
        <app-mb-select
          formControlName="sectorId"
          (handleChange)="onSectorChange($event)"
          prefixLabel="Sector:"
          placeholder="Select Sector"
          [options]="sectorOptions"
        />
      </div>
    </div>
    <div class="flex flex-col gap-2 pt-8">
      <span class="text-base font-extrabold">Assigned Location (Optional)</span>
      <span class="text-sm text-mbaza-text-secondary"
        >If no location selected, the staff will be assigned to all locations by
        default</span
      >

      <div
        class="flex flex-row gap-2 items-center border border-mbaza-gray-dark p-3 rounded-sm"
      >
        <span class="text-base font-bold">Search:</span>
        <nz-select
          formControlName="assignedLocations"
          [nzMaxTagCount]="3"
          [nzMaxTagPlaceholder]="tagPlaceHolder"
          nzBorderless="true"
          nzPlaceHolder="Search Location"
          nzMode="multiple"
          class="w-full"
        >
          @for (location of locationOptions; track location.value) {
          <nz-option
            [nzLabel]="location.label"
            [nzValue]="location.value"
          ></nz-option>
          }
        </nz-select>
        <img [src]="ASSET_CONSTANTS.I_search" alt="Search" class="h-5 w-5" />
      </div>
    </div>
  </div>
</form>
